import React from "react";

const fmtDate = (dateStr) => {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const ContextLine = ({ projectName, phaseName, onBack, isPhaseView }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 6,
      marginBottom: 8,
      minHeight: 20,
      fontSize: "0.78rem",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.04em",
    }}
  >
    {isPhaseView ? (
      <>
        <button
          onClick={onBack}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 4,
            color: "#64748b",
            padding: 0,
            fontSize: "inherit",
            fontWeight: "inherit",
            letterSpacing: "inherit",
            textTransform: "inherit",
          }}
        >
          <i className="ri-arrow-left-s-line" style={{ fontSize: "1rem" }} />
          {projectName || "Project"}
        </button>
        <i className="ri-arrow-right-s-line" style={{ color: "#cbd5e1" }} />
        <span style={{ color: "#002045" }}>{phaseName || "Phase"}</span>
      </>
    ) : (
      <span style={{ color: "#64748b" }}>
        {projectName ? `Project · ${projectName}` : "Project Overview"}
      </span>
    )}
  </div>
);

const InlineBadge = ({ active }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 5,
      background: active ? "#f0fdf4" : "#f8fafc",
      border: `1px solid ${active ? "#bbf7d0" : "#e2e8f0"}`,
      borderRadius: 99,
      padding: "3px 10px",
      verticalAlign: "middle",
    }}
  >
    <span
      style={{
        width: 6,
        height: 6,
        borderRadius: "50%",
        background: active ? "#059669" : "#94a3b8",
        flexShrink: 0,
      }}
    />
    <span
      style={{
        fontSize: "0.7rem",
        fontWeight: 700,
        color: active ? "#059669" : "#64748b",
      }}
    >
      {active ? "Active" : "Inactive"}
    </span>
  </span>
);

const ReportingHeader = ({
  projectName,
  projectId,
  phase,
  phases = [],
  onPhaseChange,
  blocks = [],
  onBlockChange,
}) => {
  const isPhaseView = !!phase;

  const title = isPhaseView ? phase?.name || "—" : projectName || "—";
  const subtitle = isPhaseView ? (
    <>
      <i className="ri-calendar-line me-1" />
      {fmtDate(phase?.starting_date)} — {fmtDate(phase?.estimated_finish_date)}
      {phase?.description ? (
        <span style={{ marginLeft: 8, opacity: 0.7 }}>· {phase.description}</span>
      ) : null}
    </>
  ) : (
    <>
      Real Estate Development &amp; Multi-Unit Residential
      {projectId ? ` | Project ID: ${projectId}` : ""}
    </>
  );

  return (
    <div style={{ marginBottom: 32 }}>
      <ContextLine
        projectName={projectName}
        phaseName={phase?.name}
        onBack={() => onPhaseChange(null)}
        isPhaseView={isPhaseView}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 16,
        }}
      >
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <h3
              style={{
                fontWeight: 800,
                fontSize: "1.75rem",
                color: "#002045",
                letterSpacing: "-0.03em",
                margin: 0,
              }}
            >
              {title}
            </h3>
            {isPhaseView && <InlineBadge active={phase?.active} />}
          </div>
          <p
            style={{
              color: "#64748b",
              fontWeight: 500,
              margin: "4px 0 0",
              fontSize: "0.875rem",
              minHeight: 20,
            }}
          >
            {subtitle}
          </p>
        </div>

        <div style={{ display: "flex", gap: 10, alignItems: "center", flexShrink: 0 }}>
          {phases.length > 0 && (
            <select
              className="form-select form-select-sm"
              value={phase?.id ? String(phase.id) : ""}
              onChange={(e) => onPhaseChange(e.target.value || null)}
              style={{
                borderRadius: 6,
                fontSize: "0.82rem",
                maxWidth: 200,
                border: "1px solid #e2e8f0",
                color: "#002045",
                fontWeight: 500,
              }}
            >
              <option value="">All Phases</option>
              {phases.map((p) => (
                <option key={p.id} value={String(p.id)}>
                  {p.name}
                </option>
              ))}
            </select>
          )}
          {blocks.length > 0 && (
            <select
              className="form-select form-select-sm"
              value=""
              onChange={(e) => e.target.value && onBlockChange(e.target.value)}
              style={{
                borderRadius: 6,
                fontSize: "0.82rem",
                maxWidth: 200,
                border: "1px solid #e2e8f0",
                color: "#002045",
                fontWeight: 500,
              }}
            >
              <option value="">View Block…</option>
              {blocks.map((b) => (
                <option key={b.id} value={String(b.id)}>
                  {b.name}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportingHeader;
